export const vendorConstants = {
    SET_PARAMS_REQUEST: 'VENDORS_SET_PARAMS_REQUEST',

    GETALL_REQUEST: 'VENDORS_GETALL_REQUEST',
    GETALL_SUCCESS: 'VENDORS_GETALL_SUCCESS',
    GETALL_FAILURE: 'VENDORS_GETALL_FAILURE',

    DELETE_REQUEST: 'VENDORS_DELETE_REQUEST',
    DELETE_SUCCESS: 'VENDORS_DELETE_SUCCESS',
    DELETE_FAILURE: 'VENDORS_DELETE_FAILURE',

    GET_REQUEST: 'VENDORS_GET_REQUEST',
    GET_SUCCESS: 'VENDORS_GET_SUCCESS',
    GET_FAILURE: 'VENDORS_GET_FAILURE',

    ADD_REQUEST: 'VENDORS_ADD_REQUEST',
    ADD_SUCCESS: 'VENDORS_ADD_SUCCESS',
    ADD_FAILURE: 'VENDORS_ADD_FAILURE',

    UPDATE_REQUEST: 'VENDORS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'VENDORS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'VENDORS_UPDATE_FAILURE',

    UPDATE_FIELD_REQUEST: 'VENDORS_UPDATE_FIELD_REQUEST',
    UPDATE_FIELD_SUCCESS: 'VENDORS_UPDATE_FIELD_SUCCESS',
    UPDATE_FIELD_FAILURE: 'VENDORS_UPDATE_FIELD_FAILURE',
}